import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { PositionSummary, PositionSummaryProps } from '@/components/PositionSummary';
import { SizedBox } from '@/components/SizedBox';
import { useAlerts } from '@/feature/alerts/hooks/use-alerts';

export const useShowPositionSummarySheet = () => {
    const { showInfoSheet } = useAlerts();
    const { t } = useTranslation('common');

    return useCallback(
        (summary: PositionSummaryProps) => {
            showInfoSheet({
                description: <PositionSummary {...summary} />,
                buttonLabel: t('close'),
                // 24 + the InfoSheet's unconditional 8pt title gap = Figma's 32 between handle and title
                containerStyle: { paddingTop: 24 },
                footerContent: <SizedBox value={8} />,
            });
        },
        [showInfoSheet, t]
    );
};
